/**
 * This composable is used to provide a Vuetify instance to components that need it.
 */

import { getCurrentInstance } from "vue";

export function useVuetify() {
  const vm = getCurrentInstance();
  if (!vm) throw new Error("useVuetify must be called from a setup function");

  return vm.proxy?.$vuetify;
}
